export const PEOPLE_FIELD_MUTATION_GROUP = 'peopleFields' as const;
